import React from 'react'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import DrinkSectionForm from './DrinkSectionForm'

const DrinCreate: React.FC = () => (
  <SectionWrapper title={'resources.drinksections.createSection'}>
    <Create>
      <DrinkSectionForm />
    </Create>
  </SectionWrapper>
)

export default DrinCreate
